<mat-card>
    <mat-card-header>
      <mat-card-title class="popupHeader">
        <div class="mat-card-header-text" i18n>
          Settings
        </div>        
      </mat-card-title> 
    </mat-card-header>
  
 <mat-card-content>
  <div>
    <table class="mat-table">    
      <!-- <tr class="mat-row ">
        <td class="mat-cell">
          <div fxLayout="row">
            <div>
              <mat-icon><img src="assets/images/building_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
            </div>
            <div class="mimg" i18n>
              Building
            </div>
          </div>
        </td>
        <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="buildingCache" disabled="true"></mat-slide-toggle></td>        
      </tr>
      <tr class="mat-row">
        <td class="mat-cell"> <div fxLayout="row">
          <div>
            <mat-icon><img src="assets/images/trench_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
          </div>
          <div class="mimg" i18n>
            Trench
          </div>
        </div>
      </td>
        <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="trenchCache" disabled="true"></mat-slide-toggle></td>        
      </tr>
      <tr class="mat-row">
        <td class="mat-cell"> <div fxLayout="row">
          <div>
            <mat-icon><img src="assets/images/duct_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
          </div>
          <div class="mimg" i18n>
            Duct
          </div>
        </div></td>
        <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="ductCache" disabled="true"></mat-slide-toggle></td>        
      </tr>
      <tr class="mat-row">
        <td class="mat-cell"> <div fxLayout="row">
          <div>
            <mat-icon><img src="assets/images/cable_PopUp_label_256_cs_mobile.png" alt=""></mat-icon>
          </div>
          <div class="mimg" i18n>
            Cable
          </div>
        </div></td>
        <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="cableCache" disabled="true"></mat-slide-toggle></td>       
      </tr>    -->
      <tr class="mat-row">
        <td class="mat-cell"> <div fxLayout="row">
          <div>
            <mat-icon><img src="assets/images/rack_icon_label_256_ cs_mobile.png" alt=""></mat-icon>
          </div>
          <div class="mimg" i18n>
            Rack
          </div>
        </div></td>
        <td class="mat-cell"><mat-slide-toggle color="primary" [checked]="rackCache"></mat-slide-toggle></td>       
      </tr> 
    </table>
  </div>
  </mat-card-content>
</mat-card>
  